export default __webpack_public_path__ + "fe266aac8d955703d140387297e5c698.png";